module.exports = "pegasus_template/assets/themecapture1/product/101.png";